import { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import { Box, Button, CircularProgress, Avatar as MuiAvatar, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next' // Import i18next

export default function Avatar({ url, size = 100, onUpload }) {
  const { t } = useTranslation() // Hook for translations
  const [avatarUrl, setAvatarUrl] = useState(null)
  const [uploading, setUploading] = useState(false)

  useEffect(() => {
    if (url) downloadImage(url)
  }, [url])

  async function downloadImage(path) {
    try {
      const { data, error } = await supabase.storage.from('avatars').download(path)
      if (error) throw error
      const url = URL.createObjectURL(data)
      setAvatarUrl(url)
    } catch (error) {
      console.log(t('avatar.errorDownload'), error.message)
    }
  }

  async function uploadAvatar(event) {
    try {
      setUploading(true)
      if (!event.target.files || event.target.files.length === 0) {
        throw new Error(t('avatar.errorNoFile'))
      }

      const file = event.target.files[0]
      const fileExt = file.name.split('.').pop()
      const fileName = `${Math.random()}.${fileExt}`
      const filePath = `${fileName}`

      let { error: uploadError } = await supabase.storage.from('avatars').upload(filePath, file)
      if (uploadError) throw uploadError

      onUpload(filePath)
    } catch (error) {
      alert(error.message)
    } finally {
      setUploading(false)
    }
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      {avatarUrl ? (
        <MuiAvatar src={avatarUrl} alt={t('avatar.altText')} sx={{ width: size, height: size }} />
      ) : (
        <MuiAvatar sx={{ width: size, height: size, bgcolor: 'grey.300' }}>
          <Typography variant="h6">?</Typography>
        </MuiAvatar>
      )}

      <input
        id="avatar-upload"
        type="file"
        accept="image/*"
        onChange={uploadAvatar}
        disabled={uploading}
        hidden
      />
      <label htmlFor="avatar-upload">
        <Button variant="contained" component="span" disabled={uploading}>
          {uploading ? <CircularProgress size={24} /> : t('avatar.uploadButton')}
        </Button>
      </label>
    </Box>
  )
}
